import React, { useMemo } from 'react';
import ListComponent from './List.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import { IProps } from './IProps';
import useDictionary from "@ui/hooks/useDictionary";

const Component: React.FC<IProps> = ({
    lang,
    demoModeError,
    serverError,
    groups,
    devices,
    selectedDevices,
    visibleList,
    settingsList,
    settingDeviceImei,
    onDeviceSelect,
    onDeviceClick,
    onShareClick,
    onGroupClick,
    onCancel,
}: IProps) => {
    const getWord = useDictionary();
    const alertMessage = useMemo(() => {
        if (serverError) return 'serverError';
        else if (demoModeError) return 'demoModeError';
        else return '';
    }, [serverError, demoModeError]);

    let curDevice = devices.filter(
        (device) => device.imei === settingDeviceImei
    )
    let dev = curDevice.find(p => p.deviceType)?.deviceType
    let filterDev = devices.filter(
        (devices) => {
            return devices.deviceType == dev
        }
    )
    return (
        <ModalComponent
            className="share-device-settings"
            title={getWord('shareDeviceSettingsTitle') + ' ' + dev + '?'}
            alertText={alertMessage}
            lang={lang}
            onClose={onCancel}
        >
            <ListComponent
                groups={groups}
                //devices={devices}
                devices={filterDev}
                selectedDevices={selectedDevices}
                visibleList={visibleList}
                settingsList={settingsList}
                settingDeviceImei={settingDeviceImei}
                onGroupClick={onGroupClick}
                onDeviceClick={onDeviceClick}
                onDeviceSelect={onDeviceSelect}
            />
            <ButtonBarComponent>
                <ButtonComponent
                    label="share"
                    lang={lang}
                    onClick={onShareClick}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onCancel}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const ShareDeviceSettingsComponent = React.memo(Component);

export default ShareDeviceSettingsComponent;
